import { useEffect } from 'react';
import { authApi, useSessionStore } from '@/entities/user';
import { setSessionExpiredHandler } from '@/shared/api';

/**
 * Resumes a session from the httpOnly refresh cookie on first load and wires the API
 * client so a failed mid-session refresh drops the user back to anonymous.
 */
export function useSessionRestore() {
  const setSession = useSessionStore((state) => state.setSession);
  const clear = useSessionStore((state) => state.clear);

  useEffect(() => {
    let cancelled = false;

    authApi.restore().then((response) => {
      if (!cancelled) {
        setSession(response?.user ?? null);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [setSession]);

  useEffect(() => {
    setSessionExpiredHandler(clear);
    return () => setSessionExpiredHandler(null);
  }, [clear]);
}
